var _g, _text;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUploadError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1386",
    "data-name": "Group 1386",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Polygon_2",
    "data-name": "Polygon 2",
    fill: "#fff",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26.25897026062012 22.99999809265137 L 1.741039991378784 22.99999809265137 L 14 1.984638810157776 L 14.00026798248291 1.985098838806152 L 26.25896072387695 22.99999809265137 L 26.25897026062012 22.99999809265137 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14.00000190734863 3.969261169433594 L 3.482072830200195 21.99999809265137 L 24.51792335510254 21.99999809265137 L 14.00000190734863 3.969261169433594 M 14 0.9846343994140625 C 14.33541965484619 0.9846343994140625 14.6708402633667 1.150009155273438 14.86378002166748 1.480758666992188 L 27.12273979187012 22.49612808227539 C 27.51161956787109 23.16278839111328 27.0307502746582 23.99999809265137 26.25896072387695 23.99999809265137 L 1.741039276123047 23.99999809265137 C 0.9692497253417969 23.99999809265137 0.4883708953857422 23.16278839111328 0.8772602081298828 22.49612808227539 L 13.13621997833252 1.480758666992188 C 13.3291597366333 1.150009155273438 13.66458034515381 0.9846343994140625 14 0.9846343994140625 Z",
    stroke: "none",
    fill: "#fff"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "!",
    transform: "translate(11 20)",
    fill: "#ca4927",
    fontSize: 16,
    fontFamily: "Georgia-Bold, Georgia",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "!"))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadError);
export default __webpack_public_path__ + "static/media/upload_error.4319a44be82f6e71213c386fd49490b5.svg";
export { ForwardRef as ReactComponent };